module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"sidewall-club","short_name":"Sidewall Club","start_url":"/","background_color":"#ffffff","theme_color":"#777777","display":"minimal-ui","icon":"src/images/swp-logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"ef7b3552b2b2461ce5637d4200c9baf1"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
